import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Card, CardActionArea, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import CampoDuracionVolcado from '../../components/configuracionDeSistema/CampoDuracionVolcado'

function ConfiguracionVolcadoras (props) {
  const { updateDuracionVolcado, duracion } = props
  const [open, setOpen] = useState()

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const onSubmit = () => {
    updateDuracionVolcado()
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        maxWidth='md'
        onClose={handleClose}
      >
        <DialogView
          confirmCallback={onSubmit}
          cancelCallback={handleClose}
          title='Editar duración de volcado'
          content={<CampoDuracionVolcado />}
        />
      </Dialog>
      <Row style={{ alignItems: 'center', padding: '5px 0', margin: 'auto' }}>
        <Col md={9}>
          <h5>Tiempo transcurrido entre cada volcado</h5>
          <p>Se utiliza principalmente para recordarle al usuario que cargue las demoras si corresponde.</p>
        </Col>
        <Col md={3}>
          <Card
            className='shadow bg-white rounded'
            style={{ margin: '0 auto', padding: '8px', height: '100%' }}
          >
            <CardActionArea
              onClick={handleOpen}
            >
              {duracion && <h2 style={{ margin: 0, padding: 0 }}> {duracion} min. </h2> }
            </CardActionArea>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default ConfiguracionVolcadoras
